<template>
  <div id="UserInfoDialog">
    <el-dialog class="eb-dialog_gray" @open="openHandler" :visible.sync="dialogVisible" width="552px">
      <div class="userInfoTop clearfix">
        <div class="red-line"></div>
        <div style="float:left">
          <div class="userInfoTopDepartLogo clearfix">
            <div class="img-middle departLogo">
              <img v-if="user.departLogo" :src="departLogoImgSrc">
              <img v-if="!user.departLogo" :src="$ebConfig.imgPath+'img/60x45.png'">
            </div>
            <span class="companyName">{{user.companyName}}</span>&ensp;<ebFontType v-if="user.authStatus === '1'">
            <span>实</span>
          </ebFontType>
          </div>
          <div class="userInfoMiddle clearfix">
            <div class="headImg">
              <div class="img-middle ">
                <img v-if="user.headImg" :src="headImgSrc">
                <img v-if="!user.headImg" :src="$ebConfig.imgPath+'img/default-headimg.jpg'">
              </div>
            </div>
            <div class="userInfoMiddleRight">
              <div class="userInfoName">{{user.showName?user.showName:user.trueMame}}</div>
              <div class="userInfoRow clearfix" v-if="user.roleId === 2 || user.roleId === 8 || user.roleId === 9 ">
                <div class="userInfoRowLeft">手机号码</div>
                <div class="userInfoRowRight">{{user.userPhone}}</div>
              </div>
              <div class="userInfoRow clearfix">
                <div class="userInfoRowLeft">工作电话</div>
                <div class="userInfoRowRight">{{user.phone}}</div>
              </div>
              <div class="userInfoRow clearfix">
                <div class="userInfoRowLeft">电子邮箱</div>
                <div class="userInfoRowRight">{{user.userEmail}}</div>
              </div>
              <div class="userInfoRow clearfix">
                <div class="userInfoRowLeft">通信地址</div>
                <div class="userInfoRowRight">{{user.address}}</div>
              </div>
              <div class="userInfoRow clearfix">
                <div class="userInfoRowLeft">微信昵称</div>
                <div class="userInfoRowRight">{{user.nickname}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="eb-line"></div>
      <div class="userInfoBottom clearfix">
        <div class="bottom-left">
          <div class="img-middle wximg">
            <img v-if="user.wxQRCodeImg" :src="wxQRCodeImgSrc">
            <img v-if="!user.wxQRCodeImg" :src="$ebConfig.imgPath+'img/weixin-default.png'">
          </div>
          <div class="wximg-text">微信二维码</div>
        </div>
        <div class="bottom-right">
          <div class="userInfoRow clearfix">
            <div class="userInfoRowLeft">自我介绍</div>
            <div class="userInfoRowRight">{{user.selfIntroduce}}</div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import eventBus from '@/plugins/event-bus';
import { getUserById } from '@/services/user/user-service';
import ebFontType from '@/components/common/eb-font-type';
import { baseURL } from '@/plugins/axios';
export default {
  name: 'UserInfoDialog',
  data() {
    return {
      dialogVisible: false,
      user: {},
      userId: ''
    };
  },
  components: {
    ebFontType
  },
  created() {
    eventBus.$on('userInfoDialog', userId => {
      this.userId = userId;
      this.dialogVisible = true;
    });
  },
  computed: {
    headImgSrc: {
      cache: true,
      get: function() {
        return baseURL + this.user.headImg + '?time=' + Date.now();
      }
    },
    wxQRCodeImgSrc: {
      cache: true,
      get: function() {
        return baseURL + this.user.wxQRCodeImg + '?time=' + Date.now();
      }
    },
    departLogoImgSrc: {
      cache: true,
      get: function() {
        return baseURL + this.user.departLogo + '?time=' + Date.now();
      }
    }

  },
  methods: {
    async getUserByIdService() {
      try {
        let { data } = await getUserById(this.userId);

        if (data.returnCode === '01') {
          this.user = data.user;
        } else {
          this.$message.error('获取信息失败');
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    openHandler: function() {
      this.getUserByIdService();
    }
  },
  beforeDestroy() {
    // eventBus.$off('userInfoDialog');
  }
};
</script>
<style scoped lang="less">
#UserInfoDialog {
  .userInfoTop {
    &:hover {
      .red-line {
        height: 15px;
        transition: height 0.5s;
      }
    }
  }
  .red-line {
    float: left;
    height: 15px;
    width: 5px;
    background-color: #fe5b3c;
    margin-right: 10px;
    transition: height 0.5s;
  }
  .departLogo {
    height: 45px;
    width: 60px;
    float: left;
    padding-right: 15px;
    img {
      max-width: 60px;
      max-height: 45px;
    }
  }

  .companyName {
    font-family: 'Microsoft YaHei';
    font-size: 16px;
    font-weight: bold;
  }
  .userInfoMiddle {
    padding-top: 20px;
  }
  .headImg {
    width: 177px;
    height: 232px;
    float: left;
    margin-right: 30px;
    .img-middle {
      height: 208px;
      width: 138px;
    }
    img {
      max-width: 138px;
      max-height: 208px;
      box-shadow: 2px 4px 2px #ccc;
    }
  }
  .userInfoMiddleRight {
    float: left;
  }
  .userInfoName {
    color: #616161;
    font-size: 24px;
    font-family: 'Microsoft YaHei';
    font-weight: 700;
    padding-bottom: 10px;
  }
  .userInfoRow {
    width: 275px;
    padding: 6px 0;
     color: #6b6b6b;
    div {
      float: left;
    }
    .userInfoRowLeft {
      font-family: 'Microsoft YaHei';
      width: 85px;
    }
    .userInfoRowRight {
      width: 185px;
    }
  }
  .userInfoBottom {
    padding-top: 20px;
    padding-left: 15px;
  }
  .bottom-left {
    float: left;
    .wximg {
      height: 142px;
      width: 142px;
      img {
        max-width: 142px;
        max-height: 142px;
      }
    }
    .wximg-text {
      font-family: 'Microsoft YaHei';
      text-align: center;
      padding-top: 5px;
    }
  }
  .bottom-right {
    padding-left: 66px;
    float: left;
  }
}
</style>
